export default "__VITE_ASSET__Gqbs5VaG__"